import { Serie } from '@api/types.generated';

import { createSerie, deleteSerie, fetchSerieList, updateSerie } from './serie.actions';
import { createReducer } from '../../../frontendUtils';
import {
  deleteArrayItemAfterAsyncCall,
  getArrayAfterAsyncCall,
  getArrayAfterAsyncCreateCall,
  updateArrayItemAfterAsyncCall,
} from '../../../frontendUtils/redux/reducers';

export type SerieState = Serie[];
export const initialState: SerieState = [];

const serieReducer = createReducer(initialState, {
  [fetchSerieList.done.type]: (state, action) => getArrayAfterAsyncCall(state, action),
  [createSerie.done.type]: (state, action) => getArrayAfterAsyncCreateCall(state, action),
  [updateSerie.done.type]: (state, action) => updateArrayItemAfterAsyncCall(state, action),
  [deleteSerie.done.type]: (state, action) => deleteArrayItemAfterAsyncCall(state, action),
});

export default serieReducer;
